/**
 * Central API Configuration
 * Single source of truth for backend Base URL across the entire frontend application.
 */
export const API_BASE_URL = 'https://velavan-finance.onrender.com';

// Convenience endpoint prefixes
export const ENDPOINTS = {
  AUTH: `${API_BASE_URL}/user`,
  COMMON_AUTH: `${API_BASE_URL}/commonUser`,
  ACCOUNTS: `${API_BASE_URL}/accounts`,
  VELAVAN_FINANCE: `${API_BASE_URL}/velavan_finance`,
  GOLD_LOAN: `${API_BASE_URL}/gold-loan`,
  VEHICLE_LOAN: `${API_BASE_URL}/vehicle-loan`,
  ADMIN: `${API_BASE_URL}/admin`,
};
  
export default API_BASE_URL;
